import {
	createRound,
	deleteRound,
	entriesList,
	roundById,
	roundsList,
	updateEntryStatus,
	updateRound,
} from '@/services/token/tokenSale.service'

export default {
	namespaced: true,
	state: {
		roundsList: { data: [], meta: { pagination: { total: 0 } } },
		round: {},
		entriesList: { data: [], meta: { pagination: { total: 0 } } },
		roundsStatus: 'init',
		roundSaveStatus: 'init',
		roundDeleteStatus: 'init',
		entriesStatus: 'init',
	},
	getters: {
		getRoundsList: state => state.roundsList,
		getRound: state => state.round,
		getEntriesList: state => state.entriesList,
		getRoundsStatus: state => state.roundsStatus,
		getRoundSaveStatus: state => state.roundSaveStatus,
		getRoundDeleteStatus: state => state.roundDeleteStatus,
		getEntriesStatus: state => state.entriesStatus,
	},
	mutations: {
		ROUNDS_LIST(state, value) { state.roundsList = value },
		SET_ROUND(state, value) { state.round = value },
		ENTRIES_LIST(state, value) { state.entriesList = value },
		ROUNDS_STATUS(state, value) { state.roundsStatus = value },
		ROUND_SAVE_STATUS(state, value) { state.roundSaveStatus = value },
		ROUND_DELETE_STATUS(state, value) { state.roundDeleteStatus = value },
		ENTRIES_STATUS(state, value) { state.entriesStatus = value },
	},
	actions: {
		async fetchRoundsList({ commit }, params) {
			commit('ROUNDS_STATUS', 'pending')
			try {
				const { data } = await roundsList(params)
				commit('ROUNDS_LIST', data)
				commit('ROUNDS_STATUS', 'init')
				return data
			} catch (error) {
				commit('ROUNDS_STATUS', 'init')
				throw error
			}
		},
		async fetchRoundByID({ commit }, id) {
			commit('ROUNDS_STATUS', 'pending')
			try {
				const { data } = await roundById(id)
				commit('SET_ROUND', data.data ?? data)
				commit('ROUNDS_STATUS', 'init')
				return data
			} catch (error) {
				commit('ROUNDS_STATUS', 'init')
				throw error
			}
		},
		async saveRound({ commit }, params) {
			commit('ROUND_SAVE_STATUS', 'pending')
			try {
				const { data } = await createRound(params)
				commit('ROUND_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('ROUND_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateRound({ commit }, params) {
			commit('ROUND_SAVE_STATUS', 'pending')
			try {
				const { data } = await updateRound(params)
				commit('ROUND_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('ROUND_SAVE_STATUS', 'init')
				throw error
			}
		},
		async removeRound({ commit }, id) {
			commit('ROUND_DELETE_STATUS', 'pending')
			try {
				const { data } = await deleteRound(id)
				commit('ROUND_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('ROUND_DELETE_STATUS', 'error')
				throw error
			}
		},
		async fetchEntriesList({ commit }, params) {
			commit('ENTRIES_STATUS', 'pending')
			try {
				const { data } = await entriesList(params)
				commit('ENTRIES_LIST', data)
				commit('ENTRIES_STATUS', 'init')
				return data
			} catch (error) {
				commit('ENTRIES_STATUS', 'init')
				throw error
			}
		},
		async setEntryStatus(_, { entryId, status }) {
			const { data } = await updateEntryStatus(entryId, status)
			return data
		},
	},
}
